<template>
    <hr
        v-if="data.line"
        class="divider"
    />

    <br v-else />
</template>

<script setup lang="ts">
import type { FooterItemDividerFragment } from '@/graphql/api'

defineProps<{
    data: FooterItemDividerFragment
}>()
</script>

<style lang="scss" scoped>
.divider {
    border: none;
    border-bottom: 1px solid $grey-300;
    margin: 0 0 20px;
}
</style>
